/**
 * loading spinner
 */
const state = {
    isLoading: false,
};

const mutations = {
    SHOW_LOADING(state) {
        state.isLoading = true;
    },
    HIDE_LOADING(state) {
        state.isLoading = false;
    },
};

const actions = {
    show({ commit }) {
        commit("SHOW_LOADING");
    },
    hide({ commit }) {
        commit("HIDE_LOADING");
    },
};

const getters = {
    isLoading: (state) => state.isLoading,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
